import React from "react";
import { PaymentMethodContainer } from "../styled";

const paymentTypes = [
  { key: "TOSS", label: "일반결제" },
  { key: "ORD", label: "발주" },
];

const PaymentMethod = ({ paymentType, setPaymentType, widgetContainerRef }) => {
  return (
    <PaymentMethodContainer>
      <p className="title">결제수단</p>
      <ul>
        {paymentTypes.map((item) => (
          <li
            onClick={() => setPaymentType(item.key)}
            className={item.key === paymentType ? "active" : "inactive"}>
            {item.label}
          </li>
        ))}
      </ul>
      <div className={`toss ${paymentType === "TOSS" ? "active" : "inactive"}`}>
        <div id="payment-widget" ref={widgetContainerRef}></div>
      </div>
    </PaymentMethodContainer>
  );
};

export default PaymentMethod;
